import { render, staticRenderFns } from "./singleNucleotide.vue?vue&type=template&id=c6137a76&scoped=true"
import script from "./singleNucleotide.vue?vue&type=script&lang=js"
export * from "./singleNucleotide.vue?vue&type=script&lang=js"
import style0 from "./singleNucleotide.vue?vue&type=style&index=0&id=c6137a76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6137a76",
  null
  
)

export default component.exports